// import { Container } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Appearance } from '@stripe/stripe-js';
import React, { useMemo } from 'react';

import { CheckoutForm } from '../components';
import { useApiRepo, Endpoints } from '../utils/Api';

export interface ICheckSubscription {
  checkSubscription: () => void;
}

/*
  Pusblishable key:
  pk_live_51M25JrG5v4ZtX1SlTdjWeQeQa8GAbitTiuUMIElJ8vKlQ
  QCamISG5T3DJzPM95XoJVwcIv5jdX4Q2vbAhWkfU0uT00pS8WLWYm
*/
export const Stripe = ({ checkSubscription }: ICheckSubscription) => {
  const { getObjectsFromAPI } = useApiRepo();
  // const [clientSecret, setClientSecret] = useState<string>('');

  const getStripePromise = async () => {
    const api = await getObjectsFromAPI();
    const { data } = await api.get(Endpoints.stripePromise);
    return loadStripe(data);
  };

  const stripePromise = useMemo(getStripePromise, []);

  const appearance: Appearance = {
    theme: 'flat',
    variables: {
      fontFamily: ' "Gill Sans", sans-serif',
      fontLineHeight: '1.5',
      borderRadius: '10px',
      colorBackground: '#F6F8FA',
      colorPrimaryText: '#262626'
    },
    rules: {
      '.Block': {
        backgroundColor: 'var(--colorBackground)',
        boxShadow: 'none',
        padding: '12px'
      },
      '.Input': {
        padding: '12px',
        borderRadius: 'none'
      },
      '.Input:disabled, .Input--invalid:disabled': {
        color: 'lightgray'
      },
      '.Tab': {
        padding: '10px 12px 8px 12px',
        border: 'none'
      },
      '.Tab:hover': {
        border: 'none',
        boxShadow:
          '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
      },
      '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
        border: 'none',
        backgroundColor: '#fff',
        boxShadow:
          '0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
      },
      '.Label': {
        fontWeight: '500'
      }
    }
  };

  const options = {
    // clientSecret,
    appearance
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm checkSubscription={checkSubscription} />
      </Elements>
    </div>
  );
};
